<template>
<form id="authForm" class="signin-container m-t animated fadeInUp" action="#" role="form" 
  v-on:submit.prevent @keyup.enter="logIn">
  <v-flex tag="h3">{{$t('view.signin.title')}}</v-flex>
  <!-- USERNAME INPUT -->
  <v-flex >
    <v-text-field 
      prepend-icon="person" 
      name="username"
      :label="$t('view.signin.username.placeholder')" 
      type="text"
      :disabled="view.action.login.busy"
      v-model.trim="auth.username"
      :error-messages="$t(`validator.${getFirstError($v.auth.username)}.text`,'')"
      v-if="!view.action.login.busy">
    </v-text-field>
		<!-- <span class="input-group-addon signin--i"><i class="icon-append fa fa-user"></i></span> 		
    <input type="text" 
      class="form-control signin--user" 
      name="username"
      :placeholder="$t('view.signin.username.placeholder')" 
      :disabled="view.action.login.busy"
      v-model.trim="auth.username"
      v-if="!view.action.login.busy"> -->
    <vue-content-loading :width="353" :height="32" v-if="view.action.login.busy">
      <rect x="0" y="0" rx="4" ry="4" width="353" height="32" />
    </vue-content-loading>    
  </v-flex>
  <!-- <label class="error--text" 
      for="username"
      v-if="hasErrors($v.auth.username)">
      {{$t(`validator.${getFirstError($v.auth.username)}.text`,"")}}
  </label> -->
  <!-- PASSWORD INPUT -->
  <v-flex>
    <v-text-field 
      prepend-icon="lock" 
      name="password" 
      :disabled="view.action.login.busy"
      v-model.trim="auth.password"
      v-if="!view.action.login.busy" 
      :error-messages="getFirstErrorDescription($v.auth.password)"
      :label="$t('view.signin.password.placeholder')"
      type="password"></v-text-field>
    <!-- <span class="input-group-addon signin--i"><i class="icon-append fa fa-lock"></i></span> 		 -->
    <!-- <input type="password" 
      name="password" 
      class="form-control signin--lock" 
      :placeholder="$t('view.signin.password.placeholder')" 
      :disabled="view.action.login.busy"
      v-model.trim="auth.password"
      v-if="!view.action.login.busy"> -->
    <vue-content-loading :width="353" :height="32" v-if="view.action.login.busy">
      <rect x="0" y="0" rx="4" ry="4" width="353" height="32" />
    </vue-content-loading>
  </v-flex>
  <!-- <label class="error--text" for="password"
      v-if="$v.auth.password.$invalid && $v.auth.password.$dirty">
      {{getFirstErrorDescription($v.auth.password)}}
  </label> -->
  <p>
    <label class="error--text" for="loginSubmit" 
      v-if="view.elem.label.loginError.visible">
      {{loginErrorMessage}}
    </label>
  </p>
  <v-layout row class="input-group" v-show="view.elem.captcha.visible">
    <v-flex id="mc">
      <p style="margin: 0px 0 0px;">Por favor dibuja la línea: </p>
      <canvas id="mc-canvas"></canvas>
    </v-flex>
    <input id="captchaResult" type="submit" style="height: 0px; padding: 0px 0px 0px 0px; margin: 0px 0px 0px 0px; border:0px 0px 0px 0px;" disabled="disabled" value="Submit Form" />
  </v-layout>
  <!-- SUBMIT BUTTON -->
  <v-btn 
  :disabled="submitButtonValidationStrategy() || view.action.login.busy" 
  name="loginSubmit"
  @submit="logIn()"
  @click="logIn()"
  block 
  color="primary">
    {{$t('view.signin.submit')}}
  </v-btn>
  <!-- <button type="button" 
    name="loginSubmit"
    class="btn btn-primary block full-width m-b signin--ingresar"
    :disabled="submitButtonValidationStrategy() || view.action.login.busy"
    @click="logIn()">
    {{$t('view.signin.submit')}}
  </button> -->
  <router-link :class="'signin--reset-pwd-link'" :to="{name:'ForgetPassword'}" :disabled="view.action.login.busy">
    <small>{{$t('view.signin.forgetpwd')}}</small>
  </router-link>
</form>
</template>
<!-- Vue Component Implementation -->
<script>
import Auth from "@/services/auth";
import * as actions from "@/constants/mutation-names";
import {AuthenticationModel} from "@/models/authentication";
import transform from "@/helpers/transformations";
import {valueIsWithin} from "@/helpers/validators";
import {required, minLength} from "vuelidate/lib/validators";
import {isBooleanValue, alphaNumDot} from '@/helpers/vuelidate/validators'
import {allValidatorMethods} from "@/helpers/vuelidate"
import {errors} from "@/locales/languages/es_MX";
import VueContentLoading from 'vue-content-loading';

// List of errors required for login flow
const errorsAPILogin = Object.keys(errors.login);
const errorsExpiredPassword = Object.keys(errors.expiredPassword);

//Element's Settings
const label = {
  loginError:{
    visible:false
    , text : ""
  }
};
const button = {
  login:{
    enable:true
  }
};
//Action's state
const action = {
  login:{
    busy:false
  }
};
// Strategies
function submitButtonValidationLoginStrategy(){
  return this.hasErrors(this.$v.auth)
}
function submitButtonValidationCaptchaStrategy(){
  this.$v.captcha.$touch();
  return this.hasErrors(this.$v.captcha) || this.hasErrors(this.$v.auth)
}
//Validation strategies
function loginValidationStrategy(){
  this.$v.auth.$touch()
  return this.isAllValid(this.$v.auth)
}
function captchaValidationStrategy(){
  this.captcha.value = !this.view.elem.captcha.domElement.disabled;
  let isValid = this.isAllValid(this.$v.auth) && this.isAllValid(this.$v.captcha)
  if(isValid){
    this.resetValidationStrategy();
    this.view.elem.captcha.domElement.visible=false;
    this.captcha.value=false;
    this.view.elem.captcha.canvas.classList = "";
    this.$v.captcha.$reset();
  }
  return isValid
}
// Vue Instance
export default {
  name: "SignIn",
  head:{
    title:function(){
      return {
        inner       : this.view.title
        , separator : '|'
        , complement: this.$t("view.home.system.initials")
      }
    }
  }
  , data() {
    return {
      auth:undefined
      , captcha:{
        value:false
      }
      , locale: this.$i18n.locale
      , view:{
        title:"Login"
        , action
        , elem:{
          label
          , button
          , captcha:{
            domElement:undefined
            , canvas:undefined
            , visible:false 
          }
        }
      }
      , validationStrategy:loginValidationStrategy
      , submitButtonValidationStrategy:submitButtonValidationLoginStrategy
    };
  }
  ,methods: {
    ...allValidatorMethods
    , setValidationStrategy(strategy){
      this.validationStrategy = strategy;
      this.setSubmitButtonValidationStrategy(submitButtonValidationCaptchaStrategy);
    }
    , setSubmitButtonValidationStrategy(strategy){
      this.submitButtonValidationStrategy=strategy;
    }
    , resetValidationStrategy(){
      this.validationStrategy = loginValidationStrategy;
      this.view.elem.captcha.visible=false;
      this.resetSubmitButtonValidationStrategy();
    }
    , resetSubmitButtonValidationStrategy(){
      this.submitButtonValidationStrategy=submitButtonValidationLoginStrategy;
    }
    , validateForm(){
      return this.validationStrategy()
    }
    , async logIn() {
      try{
        // Hide any previous error
        this.hideErrorLogIn();
        // Validate all models before make the request
        if(!this.validateForm()){
          return;
        }
        //Show busy skeleton
        this.view.action.login.busy=true;
        //Call API Login
        const response = await Auth.logIn(this.auth);      
        this.view.action.login.busy=false;
        let {data:{results:{token:userToken, usuario, roles}}} = response;
        // Transform data for store login action
        const data = {...transform.ResponseToUserStore(usuario), userToken, roles};
        // Saving data state on store
        this.$store.dispatch(actions.AUTH_LOGIN,data);
        this.$userPermission.set({roles});
        //Login success, route to home
        this.$router.push("/home");
      }catch(error){
        // console.log(error)
        //Finish busy flag for login action
        this.view.action.login.busy=false;
        //Handling error protocols
        if(error && (error.status=="500" || error.status == "504"  || error.status == "403")){
          this.showErrorLogIn(this.$t(`network.errors.${error.status}.desc`));
          return;
        }
        // Extract errorCode
        const {data:{meta:{code:errorCode}}} = error;
        // Login's error
        if(valueIsWithin(errorsAPILogin,errorCode))
          this.showErrorLogIn(this.$t(`errors.login.${errorCode}.text`));
        // Password Expired's error
        if(valueIsWithin(errorsExpiredPassword,errorCode)){
          const {data:{results:{usuario:{nombre:nombre}}}} = error; 
          this.$router.push({ name: 'ExpiredPwdMessage', params: { username: this.auth.username, nombre: nombre }})
        }
        //Captcha error handler INVALID_PASSWORD_CAPTCHA = SC0012
        if(errorCode=="SC0012"){
          this.setValidationStrategy(captchaValidationStrategy);
          this.setInitialCaptchaState();
        }
      }
      event.target.disabled = false;
    }
    , showErrorLogIn(message){
      this.view.elem.label.loginError.text = message;
      this.view.elem.label.loginError.visible = true;
    }  
    , hideErrorLogIn(){
      if(!this.view.elem.label.loginError.visible)
         return;
      this.view.elem.label.loginError.text = "";
      this.view.elem.label.loginError.visible = false;
    }
    , logOut() {
      this.$store.dispatch(actions.AUTH_LOGOUT);
    }  
    , routeToViewExpiredPassword(){
      this.$router.push({ path: '/expiredpwd', query: { username: this.auth.username }})
    }
    , setInitialState(){
      this.auth = new AuthenticationModel();
      this.view.elem.label.loginError.visible=false;
      this.view.elem.label.loginError.text="";
    }
    , setInitialCaptchaState(){    
      this.view.elem.captcha.domElement= document.getElementById('captchaResult');
      window.$('#authForm').motionCaptcha({
        errorMsg   : String.fromCharCode(parseInt("2715", 16)),
        successMsg : String.fromCharCode(parseInt("2713", 16)),
        submitId   : '#captchaResult',
        canvasFont : '13px "open sans", "Helvetica Neue", "Helvetica", "Arial", "sans-serif"',
      });
      this.view.elem.captcha.visible = true;
      //keep reference of captcha element
      const captchaValue = this.captcha;
      const captchaResult = this.view.elem.captcha.domElement;
      //keep reference of canvas element 
      this.view.elem.captcha.canvas= document.getElementById('mc-canvas');
      this.view.elem.captcha.canvas.addEventListener('click',function(event){
        captchaValue.value = !captchaResult.disabled;
      }, false);
      document.querySelector('#imageLogo').style.height = "0vh";
    }
  }
  , computed:{
    loginErrorMessage(){
      return this.view.elem.label.loginError.text
    }
  }
  , validations:{
    auth:{
      username:{
        required
        , alphaNumDot
      }
      , password:{
        required
        , minLength:minLength(8)
      }
    }
    , captcha:{
      value:{
        isBooleanValue:isBooleanValue(true)
      }
    }
  }
  , components: {
    VueContentLoading
    
  }
  // Instance Lifecycle Hooks
  , created(){
    this.setInitialState();
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.signin-container{
  position:relative;
  text-align: center;
}
.btn-primary {
    color: #fff;
    background-color: #337ab7;
    border-color: #2e6da4;
}
</style>



// WEBPACK FOOTER //
// src/views/authentication/SignIn.vue